import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import NewProgramChangeRequestStep4Form from '../../../../components/forms/postSecondary/NewProgramChangeRequestStep4Form';
import Routes from '../../../../config/Routes';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import InstitutionDTO from '../../../../models/InstitutionDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NewProgramChangeRequestStep4PageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface NewProgramChangeRequestStep4PageProps {
  selectedInstitution: InstitutionDTO | null;
  currentUser: UserSecurity | null;
}

class NewProgramChangeRequestStep4Page extends React.Component<NewProgramChangeRequestStep4PageProps & RouteComponentProps<RouteObject>, NewProgramChangeRequestStep4PageState> {

  constructor(props: NewProgramChangeRequestStep4PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');

    if (id == 'new') {
      this.setState({ isNew: true });
    }
    else if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  private goToNextStep = () => {
    if (this.state.changeRequest.newProgramChangeRequest?.isTransferMajorProgram) {
      HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_7, { id: this.state.changeRequestId }));
    }
    else {
      HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_5, { id: this.state.changeRequestId }));
    }
  }

  goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_3, { id: this.state.changeRequestId }, {}))
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={3}
          currentUser={this.props.currentUser ?? {} as UserSecurity}
        >
          <Card title="Consultant Meetings" >
            <NewProgramChangeRequestStep4Form
              changeRequestId={this.state.changeRequest.id}
              selectedInstitution={this.props.selectedInstitution ? this.props.selectedInstitution.id : this.state.changeRequest.institutionId}
              onSubmit={this.goToNextStep}
              onPrevious={this.goToPreviousStep}
            />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapDispatchToProps() {
  return {
  };
}

function mapStateToProps(state: StateStoreModel) {
  return {
    selectedInstitution: state.Institution.Selected,
    currentUser: state.UserSession.Value
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewProgramChangeRequestStep4Page));